import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgSms(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="11 12 37 35"
      fill="none"
      {...props}
    >
      <path
        fill={props.primaryColor}
        d="m19.743 40.972-3.877 3.877q-.8.8-1.834.359-1.034-.443-1.032-1.581V17.37q0-1.39.991-2.38t2.38-.991h26.972q1.39 0 2.382.991.99.991.99 2.38v20.23a3.25 3.25 0 0 1-.99 2.381q-.99.99-2.382.99zM18.31 37.6h25.033V17.371H16.371v22.126z"
      />
      <path
        fill={props.secondaryColor}
        d="M24.8 27.486q0 .716-.484 1.2-.487.48-1.202.486a1.6 1.6 0 0 1-1.2-.484 1.64 1.64 0 0 1-.485-1.202q0-.714.485-1.2a1.62 1.62 0 0 1 1.2-.486 1.64 1.64 0 0 1 1.2.485q.486.485.486 1.2M31.543 27.486q0 .719-.484 1.2-.487.48-1.202.486a1.6 1.6 0 0 1-1.2-.484 1.64 1.64 0 0 1-.485-1.202q0-.712.485-1.2a1.61 1.61 0 0 1 1.2-.486q.715.003 1.2.485.486.483.486 1.2M38.286 27.486q0 .719-.484 1.2-.487.48-1.202.486a1.6 1.6 0 0 1-1.2-.484 1.64 1.64 0 0 1-.486-1.202q0-.712.486-1.2a1.61 1.61 0 0 1 1.2-.486q.715.003 1.2.485.486.483.486 1.2"
      />
    </svg>
  );
}
export default SvgSms;
